import { ReactNode } from 'react';

const ModalTitle = ({ children }: { children: ReactNode }) => {
    return <div className='modal-title'>{children}</div>;
};

export default ModalTitle;
